import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { useState } from "react";
import "../styles/sideBar.css";
import { signOut } from "firebase/auth";
import Client from "./client";
import Docs from "./docs";
import Gala from "./gala";
import TicketIcon from "./ticketIcon";

export default function UserSideBar({isToogle, toogle}) {

    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
      setIsOpen(!isOpen);
    };
  
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);        
            navigate('/');
        } catch (error) {
            console.error('Błąd podczas wylogowania:', error);
        }
    }

    return (
      <>
        {!isOpen &&
            <button
            className={`menu-button ${isOpen ? "active" : ""}`}
            onClick={toggleSidebar}
            aria-label="Toggle Menu"
            >
            <div className="menu-icon-bar" />
            <div className="menu-icon-bar" />
            <div className="menu-icon-bar" />
            </button>
        }
  
        <nav className={isToogle ? isOpen ? "sidebar sidebar--open" : `sidebar--toogle` : `sidebar ${isOpen ? "sidebar--open" : ""}`}>  
            <img className="side-arrow" src={process.env.PUBLIC_URL + "/sideArrow.png"} style={({transform: isToogle ? "rotate(180deg)" : "", width: "25px", position: "absolute", right: "-20px", top: "10px", backgroundColor: "#ffffff", padding: "5px", borderRadius: "50px", border: "1px solid rgb(230,230,230)", zIndex: "2000", cursor: "pointer"})} onClick={toogle}/>
            <ul>
                <img src={process.env.PUBLIC_URL + "/logo4STARS.png"} style={({width: isToogle ? isOpen ? "0px" : "60px" : "0px"})}/>
                <img src={process.env.PUBLIC_URL + "/logo_fullname_black.png"} style={({width: isToogle ? isOpen ? "100%" : "0px" : "100%"})}/>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/panel-klienta"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Client color={location?.pathname === "/panel-klienta" ? "#0045C7" : "rgb(30,30,30)"} wth={"25px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/panel-klienta" ? "#0045C7" : "rgb(30,30,30)"})}>Panel klienta</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/dokumentacja"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Docs color={location?.pathname === "/dokumentacja" ? "#0045C7" : "rgb(30,30,30)"} wth={"25px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/dokumentacja" ? "#0045C7" : "rgb(30,30,30)"})}>Dokumentacja</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/gala"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Gala color={location?.pathname === "/gala" ? "#0045C7" : "rgb(30,30,30)"} wth={"25px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/gala" ? "#0045C7" : "rgb(30,30,30)"})}>Kup bilet</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/rezerwacje"} onClick={() => setIsOpen(false)}>
                    <li>
                        <TicketIcon color={location?.pathname === "/rezerwacje" ? "#0045C7" : "rgb(30,30,30)"} wth={"25px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/rezerwacje" ? "#0045C7" : "rgb(30,30,30)"})}>Twoje bilety</h3>}
                    </li>
                </Link>
            </ul>
            <ul>
                    <li onClick={() => handleLogout()}>
                        <img src={process.env.PUBLIC_URL + "logout.svg"} style={({width: "22px"})}/>
                        {(!isToogle || isOpen) && <h3 style={({color: "rgb(30,30,30)"})}>Wyloguj się</h3>}
                    </li>
            </ul>
        </nav>
        {isOpen && <div className="overlay" onClick={toggleSidebar} />}
      </>
    );
}